module.exports = __webpack_public_path__ + "img/11-preview.d6048058.jpg";